export class SessionManager {
    constructor(_context) { }
    async upsertSession(_deviceId, _deviceRecord, _sessionOrigin) {
        // TODO: how should it be implemented if called from inside of service worker???
    }
}
//# sourceMappingURL=SessionManager.js.map